<template>
  <div id="nav">
    <div class="box-wrap-100 bg-dark">
      <b-button pill variant="outline-info" class="mb-2" @click="clearFilter">HOME</b-button>

      <b-button pill variant="outline-info" class="mb-2" @click="setFilterFavorita">Favorita</b-button>
      <b-button
        v-for="tag in filteredTagList"
        :key="tag.category_id"
        pill
        variant="outline-info"
        class="mb-2"
        @click="setFilter(tag.name)"
      >
        <!--b-icon icon="house"></b-icon-->
        {{getTittle(tag.name)}}
      </b-button>
      <b-button pill variant="outline-danger" class="mb-2" @click="desconectar">
        <!--b-icon icon="power" aria-hidden="true"></b-icon-->
        Logout
      </b-button>
    <div class="box-header bg-dark box-fex-start">
      <div class="box-100">
        <b-button
          pill
          class="dropdown-toggle"
          href="#"
          id="navbarDropdownMenuLink"
          role="button"
          data-toggle="dropdown"
          variant="outline-info"
        >Sub Categorías</b-button>
        <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
          <button class="dropdown-item" @click="unSetSubcategory">quitar categoria</button>
          <button
            class="dropdown-item"
            v-for="(subTag, key) in filteredSubTagList"
            :key="key"
            @click="setSubcategory(subTag.name)"
          >{{subTag.name}}</button>
        </div>
      <!--/div>
      <div class="box-100 box-fex-start"-->
          <b-form-input
            id="filterBodyQst"
            size="sm"
            class="mr-sm-2"
            placeholder="Buscar pregunta"
            right
            @update="filterBodyQuest"
            @keyup.enter="disabledEnter"
          ></b-form-input>
          <!--b-button class="btn btn-info" @click="filterBodyQuest" right>Buscar</b-button-->
        <!--/b-nav-form>

        <b-nav-form-->
          <b-form-input
            id="filterBodyQA"
            size="sm"
            class="mr-sm-2"
            placeholder="Buscar respuesta"
            right
            @update="filterBodyQa"
            @keyup.enter="disabledEnter"
          ></b-form-input>
          <!--b-button class="btn btn-info" @click="filterBodyQa" right>Buscar</b-button-->
          <b-button pill variant="outline-info" class="trash-btn" @click="clearFilterButton">
            <b-icon-trash-fill></b-icon-trash-fill>
          </b-button>
        
      </div>
    </div>
    </div>
  </div>
</template>    

<script>
import { getAllCategories } from "./../api/conection";
import { logout } from "./../api/conection";
export default {
  name: "AppHeaderOperario",
  props: {
    tagsList: {
      type: Array,
      default: []
    },
    filterCategory: {
      type: String,
      default: ""
    }
  },
  mounted() {
    getAllCategories()
      .then(response => {        
        if (response.status === 200)
          this.$store.dispatch("setCategoriesAction", response.body);
      })
      .catch(err => {
        console.log(err);
      })
  },
  computed: {
    filteredTagList() {
      return this.tagsList.filter(tsk => {
        return tsk.is_menu;
      });
    },
    filteredSubTagList() {
      //debugger;
      const category = this.tagsList.find(
        tsk => tsk.name === this.filterCategory
      );
      //console.log("dropdown", category);
      return category ? category.subcategories : [];
    }
  },
  methods: {
    disabledEnter() {
      return false;
    },
    getTittle(titel) {
      return this._.startCase(this._.toLower(titel));
    },
    setFilter(tag_name) {
      this.clearFilterImputs();
      this.$store.dispatch("setCategoryFilterAction", tag_name);
    },
    setFilterFavorita() {
      this.clearFilterImputs();
      this.$store.dispatch("setFavoriteFilterAction", 'FAVORITA');
    },
    clearFilter() {
      this.clearFilterImputs();
      this.$store.dispatch("unSetAllFiltersAction");
    },
    clearFilterButton() {
      this.clearFilterImputs();
      this.$store.dispatch("unSetAllSubFiltersAction");
    },
    unSetSubcategory() {
      this.$store.dispatch("unSetCategoryFilterAction");
    },
    setSubcategory(subTagName) {
      this.$store.dispatch("setSubCategoryFilterAction", subTagName);
    },
    filterBodyQuest() {
      const filterBodyQst = this.$el.querySelector("#filterBodyQst").value;
      //console.log("search", filterBodyQst);
      this.$store.dispatch("setFilterBodyQAAction", filterBodyQst);
    },
    filterBodyQa() {
      const filterBodyQA = this.$el.querySelector("#filterBodyQA").value;
      //console.log("search",filterBodyQA);
      this.$store.dispatch("setFilterBodyAnswerAction", filterBodyQA);
    },
    desconectar() {
      logout().then(result => {
        window.location.reload();
      });
    },
    clearFilterImputs() {
      this.$el.querySelector("#filterBodyQst").value = "";
      this.$el.querySelector("#filterBodyQA").value = "";
    }
  },
  data() {
    return {
      tittle: "HeaderOperario",
      subCategories: {
        type: Array,
        default: []
      }
    };
  }
};
</script>
<style>
.trash-btn {  
  height: 37px;
  margin-top: 3px;
}
#navbarDropdownMenuLink {
  height: 37px;
  margin-top: 3px;
}
#nav {
  /*display:flex;*/
  left: 0;
  width: 100vw;
}
</style>